class ModalDrawer extends HTMLElement {
  constructor() {
    super();
    this.activeClass = "active";
    this.sectionId = this.getAttribute("section-id");
    this.overlay = this.querySelector('[part="overlay"]');
    this.drawer = this.querySelector('[part="drawer"]');
    this.closeButton = this.querySelector('[part="close"]');

    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
  }

  connectedCallback() {
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", (e) => {
        const selectedNode = e.target;

        // Find the modal drawer *inside* the selected section (e.g. inside group-modals)
        const modal = selectedNode.querySelector?.("modal-drawer");

        if (modal && typeof modal.openDrawer === "function") {
          // Close all other modals
          document.querySelectorAll("modal-drawer").forEach((el) => {
            if (el !== modal && el.classList.contains(el.activeClass)) {
              el.closeDrawer();
            }
          });

          modal.openDrawer();
        }
      });

      document.addEventListener("shopify:section:deselect", (e) => {
        const deselectedNode = e.target;
        const modal = deselectedNode.querySelector?.("modal-drawer");
        if (modal && typeof modal.closeDrawer === "function") {
          modal.closeDrawer();
        }
      });
    }

    if (!window.__modalTriggerBound) {
      document.addEventListener("click", (e) => {
        const trigger = e.target.closest(".modal-trigger");
        if (!trigger) return;

        const sectionId = trigger.dataset.sectionId;
        const modal = document.querySelector(
          `modal-drawer[section-id="${sectionId}"]`
        );
        if (modal && typeof modal.openDrawer === "function") {
          modal.openDrawer();
        }
      });
      window.__modalTriggerBound = true;
    }

    this.overlay?.addEventListener("click", this.closeDrawer);
    this.closeButton?.addEventListener("click", this.closeDrawer);
    document.addEventListener("keydown", this.handleEscape);
  }

  disconnectedCallback() {
    this.overlay?.removeEventListener("click", this.closeDrawer);
    this.closeButton?.removeEventListener("click", this.closeDrawer);
    document.removeEventListener("keydown", this.handleEscape);
  }

  openDrawer() {
    this.setAttribute("aria-hidden", "false");
    this.classList.add(this.activeClass);
    document.body.style.overflow = "hidden";

    window.theme?.a11y?.trapFocus(this, {
      elementToFocus: this.closeButton || this,
    });
  }

  closeDrawer() {
    this.classList.remove(this.activeClass);
    this.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";

    window.theme?.a11y?.removeTrapFocus(this);
  }

  handleEscape(e) {
    if (e.key === "Escape" && this.classList.contains(this.activeClass)) {
      this.closeDrawer();
    }
  }
}

if (!customElements.get("modal-drawer")) {
  customElements.define("modal-drawer", ModalDrawer);
}
